import type { Eigendom } from '@fleet/shared';
import { EIGENDOM_LABEL } from '@fleet/shared';
import { ConfirmModal } from '../../components/ui/ConfirmModal';

/**
 * Confirmation for a change of ownership form.
 *
 * The ownership form decides which cards the page shows at all — a leased or
 * borrowed car has no purchase value and no road tax of ours — so changing it
 * reshapes half the page and puts existing data out of sight. It is edited
 * behind the pencil like every other field, but this one still spells out what is
 * about to happen before it happens.
 */
/** What disappears or appears, so the confirmation can be specific. */
const GEVOLG: Record<Eigendom, string> = {
  EIGEN: 'De kaarten Waarde en Wegenbelasting komen terug op de pagina.',
  LEASE:
    'Waarde en Wegenbelasting verdwijnen van de pagina — bij lease is de auto niet ons bezit en zit de wegenbelasting in de maandtermijn. In plaats daarvan vul je de leasegegevens in.',
  LEEN: 'Waarde en Wegenbelasting verdwijnen van de pagina. In plaats daarvan vul je het maandbedrag van de leenauto in.',
};

export function EigendomBevestiging({
  naar,
  busy,
  error,
  onBevestig,
  onAnnuleer,
}: {
  naar: Eigendom;
  busy?: boolean;
  error?: string;
  onBevestig: () => void;
  onAnnuleer: () => void;
}) {
  return (
    <ConfirmModal
      title="Eigendomsvorm wijzigen"
      message={`Deze auto wordt "${EIGENDOM_LABEL[naar]}". ${GEVOLG[naar]}`}
      confirmLabel="Wijzigen"
      busy={busy}
      error={error}
      extra={
        <p style={{ margin: 0, fontSize: 13, color: '#666666', lineHeight: 1.5 }}>
          Ingevulde gegevens blijven bewaard en komen terug als je terugschakelt.
        </p>
      }
      onConfirm={onBevestig}
      onClose={onAnnuleer}
    />
  );
}
